import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: "primary" | "secondary" | "ghost" | "danger";
  readonly wide?: boolean;
  readonly icon?: ReactNode;
}

export function Button({
  variant = "primary",
  wide = false,
  icon,
  className = "",
  children,
  type = "button",
  ...props
}: ButtonProps) {
  const classes = [
    "button",
    `button--${variant}`,
    wide ? "button--wide" : "",
    className
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} type={type} {...props}>
      {icon === undefined ? null : <span className="button__icon">{icon}</span>}
      <span>{children}</span>
    </button>
  );
}
